import { render, staticRenderFns } from "./IconImport.vue?vue&type=template&id=52d9736e&"
var script = {}
import style0 from "./IconImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d9736e')) {
      api.createRecord('52d9736e', component.options)
    } else {
      api.reload('52d9736e', component.options)
    }
    module.hot.accept("./IconImport.vue?vue&type=template&id=52d9736e&", function () {
      api.rerender('52d9736e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconImport.vue"
export default component.exports